import { render, staticRenderFns } from "./Tekst.vue?vue&type=template&id=0273b5cd&"
import script from "./Tekst.vue?vue&type=script&lang=js&"
export * from "./Tekst.vue?vue&type=script&lang=js&"
import style0 from "./Tekst.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports